export const INPUTS = {
  TOTAL_CALORIES: 'totalCalories',
  PROTEIN: 'protein',
  FAT: 'fat',
  MOISTURE: 'moisture',
  FIBER: 'fiber',
  ASH: 'ash',
  CALCIUM: 'calcium',
  PHOSPHORUS: 'phosphorus',
}

export const INPUTS_ATTRIBUTES = {
  [INPUTS.TOTAL_CALORIES]: {
    name: 'totalCalories',
    label: 'Total calories (總體熱量) Kcal',
  },
  [INPUTS.PROTEIN]: {
    name: 'protein',
    label: 'Protein (蛋白質)%',
  },
  [INPUTS.FAT]: {
    name: 'fat',
    label: 'Fat (脂肪)%',
  },
  [INPUTS.MOISTURE]: {
    name: 'moisture',
    label: 'Moisture (水份)%',
  },
  [INPUTS.FIBER]: {
    name: 'fiber',
    label: 'Fiber (纖維)%',
  },
  [INPUTS.ASH]: {
    name: 'ash',
    label: 'Ash (灰份)%',
  },
  [INPUTS.CALCIUM]: {
    name: 'calcium',
    label: 'Calcium (鈣)%',
  },
  [INPUTS.PHOSPHORUS]: {
    name: 'phosphorus',
    label: 'Phosphorus (磷)%',
  },
}
